import { render } from "./MyEconomy.vue?vue&type=template&id=26ed60b0&scoped=true"
import script from "./MyEconomy.vue?vue&type=script&lang=js"
export * from "./MyEconomy.vue?vue&type=script&lang=js"

import "./MyEconomy.vue?vue&type=style&index=0&id=26ed60b0&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26ed60b0"]])

export default __exports__